import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

const ReferencePickerError = ({ onTryAgain, className, style, children }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return (
    <div
      className={className}
      css={[
        {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
        },
        style,
      ]}
    >
      <AlertWarningIcon
        style={{
          color: theme.colors.charcoal700,
        }}
      />
      <span
        css={[
          {
            marginLeft: 9,
            marginRight: 8,
            color: theme.colors.charcoal700,
          },
          theme.typography.bodySmall,
        ]}
      >
        {children || T.translate('ERROR_LOADING')}
      </span>
      <LinkButton size={LinkButton.SIZES.SMALL} onClick={onTryAgain}>
        {T.translate('TRY_AGAIN')}
      </LinkButton>
    </div>
  );
};

ReferencePickerError.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Handler for retry fetching data */
  onTryAgain: PropTypes.func,
  /** The error's text, using default text if missing */
  children: PropTypes.node,
};

export default ReferencePickerError;
